import type { OTPAuthType } from '../../types/types';
import { BASEURL, ENDPOINTS } from '../endpoints';
import { SPXAPI } from '../interfaces';

export const LINK_RECIPIENT_CODE_MISMATCH = 'CodeMismatchException';

interface VerifyLinkRecipientCodeResponse {
    email?: string;
}

interface VerifyLinkRecipientCodeFailure {
    response?: { data?: { message?: string } };
}

const codeMismatchError = (): Error => Object.assign(
    new Error(LINK_RECIPIENT_CODE_MISMATCH),
    { name: LINK_RECIPIENT_CODE_MISMATCH },
);

export const verifyLinkRecipientCode = async (
    APIInstance: SPXAPI, linkId: string, challengeId: string, code: string, method?: OTPAuthType,
): Promise<string> => {
    const body = {
        linkId, challengeId, code, ...(method ? { method } : {}),
    };
    let response: VerifyLinkRecipientCodeResponse;
    try {
        response = await APIInstance.post(BASEURL.backend(), ENDPOINTS.verifyLinkRecipientCode(), { body });
    } catch (error) {
        if ((error as VerifyLinkRecipientCodeFailure)?.response?.data?.message === LINK_RECIPIENT_CODE_MISMATCH) {
            throw codeMismatchError();
        }
        throw error;
    }
    const email = typeof response?.email === 'string' ? response.email.trim().toLowerCase() : '';
    if (!email) {
        throw codeMismatchError();
    }
    return email;
};
